var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M79 117H39V162H79V117Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M144 117H104V162H144V117Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M209 117H169V162H209V117Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M79 117H39V160H79V117Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M144 117H104V160H144V117Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M209 117H169V160H209V117Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219 157.006H29C23.475 157.006 19 152.531 19 147.006V127.006C19 121.481 23.475 117.006 29 117.006H219C224.525 117.006 229 121.481 229 127.006V147.006C229 152.526 224.525 157.006 219 157.006Z",
    fill: "url(#paint0_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M79 37H39V82H79V37Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M144 37H104V82H144V37Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M209 37H169V82H209V37Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M79 37H39V80H79V37Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M144 37H104V80H144V37Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M209 37H169V80H209V37Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219 77.0059H29C23.475 77.0059 19 72.5309 19 67.0059V47.0059C19 41.4809 23.475 37.0059 29 37.0059H219C224.525 37.0059 229 41.4809 229 47.0059V67.0059C229 72.5259 224.525 77.0059 219 77.0059Z",
    fill: "url(#paint1_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M71 72H31V122H71V72Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M71 152H31V197H71V152Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M136 72H96V122H136V72Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M136 152H96V197H136V152Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M201 72H161V122H201V72Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M201 152H161V197H201V152Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M71 74.5H31V119.5H71V74.5Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M71 155H31V197H71V155Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M136 74.5H96V119.5H136V74.5Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M136 155H96V197H136V155Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M201 74.5H161V119.5H201V74.5Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M201 155H161V197H201V155Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M211 117.006H21C15.475 117.006 11 112.531 11 107.006V87.0059C11 81.4809 15.475 77.0059 21 77.0059H211C216.525 77.0059 221 81.4809 221 87.0059V107.006C221 112.526 216.525 117.006 211 117.006Z",
    fill: "url(#paint2_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211 197.006H21C15.475 197.006 11 192.531 11 187.006V167.006C11 161.481 15.475 157.006 21 157.006H211C216.525 157.006 221 161.481 221 167.006V187.006C221 192.526 216.525 197.006 211 197.006Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 97.72,
    y1: 87.5809,
    x2: 157.28,
    y2: 199.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#ACAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C868E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 97.72,
    y1: 7.58086,
    x2: 157.28,
    y2: 119.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697681"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 89.14,
    y1: 46.4909,
    x2: 148.7,
    y2: 158.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#ABADAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737E88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 89.14,
    y1: 126.491,
    x2: 148.7,
    y2: 238.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#A9ABAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838C93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiding);
export default __webpack_public_path__ + "static/media/siding.348cee8a341675b9fdc2732e1c452f00.svg";
export { ForwardRef as ReactComponent };